<div class="modal-content" [ngClass]="{ 'anpp': isAnpp }">
  <div class="modal-header">
    <h5 class="modal-title" id="exampleModalLabel">
      <fa-icon icon="plus-square" class="primary-icon"></fa-icon>
      <b translate> page.inventaire-verger.modals.localisations.localisationTitle</b></h5>
    <div class="pointer ms-auto" data-dismiss="modal" aria-label="Close">
      <fa-icon icon="times" (click)="cancel()" (keydown.enter)="cancel()"></fa-icon>
    </div>
  </div>
  <div class="modal-body">
    <div ngbAccordion [destroyOnHide]='false' [closeOthers]="true" #shadow="ngbAccordion">
      <!-- ================= PANEL : Liste localisations ================= -->
      <div ngbAccordionItem="panelListeLocalisation">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton (click)="setActivePanel('panelListeLocalisation')">
            {{'page.inventaire-verger.modals.add-bloc.panelTitleListeLoca'|translate }}
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div ngbAccordionBody>
            <div class="mb-3">
              <table  class="table table-striped" aria-label="Liste des localisations">
                <thead>
                  <tr>
                    <th translate>page.inventaire-verger.modals.add-bloc.operation</th>
                    @if (show('departement')) { <th translate>page.inventaire-verger.departement</th> }
                    @if (show('commune')) { <th translate>page.inventaire-verger.commune</th> }
                    @if (show('lieuDit')) { <th translate>page.inventaire-verger.lieuDit</th> }
                    @if (show('refCadastrale')) { <th translate>page.inventaire-verger.refCadastrale</th> }
                    @if (show('situation')) { <th translate>page.inventaire-verger.situation</th> }
                    @if (show('systemeIrrigation')) { <th translate>page.inventaire-verger.systemeIrrigation</th> }
                    @if (show('protectionGrele')) { <th translate>page.inventaire-verger.protectionGrele</th> }
                    @if (show('protectionGel')) { <th translate>page.inventaire-verger.protectionGel</th> }
                    @if (show('forme')) { <th translate>page.inventaire-verger.forme</th> }
                    @if (show('cultureBio')) { <th translate>page.inventaire-verger.cultureBio</th> }
                    @if (show('nbBloc')) { <th translate>page.inventaire-verger.modals.add-bloc.nbBlocsLoca</th> }
                    <th>
                      <fa-icon class="clickable-icon" icon="ellipsis-h" (click)="showList()"></fa-icon>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @if (localisations?.length === 0) {
                    <tr>
                      <td colspan="99" class="p-4"><fa-icon icon="exclamation-triangle"></fa-icon>&nbsp;
                        <span translate>page.inventaire-verger.modals.localisations.no_localisations</span>
                      </td>
                    </tr>
                  } @else {
                    @for (localisation of localisations; track localisation.id) {
                      <tr>
                        <td>
                          <div class="btn-group dropright  ">
                            <div ngbDropdown>
                              <button class="btn btn-secondary dropdown-toggle btnprimary btn-sm "
                                      id="dropdownConfig" ngbDropdownToggle>
                                <fa-icon icon="cog"></fa-icon>
                              </button>
                              <div ngbDropdownMenu aria-labelledby="dropdownConfig">
                                <button (click)="modifierLocalisation(localisation)" ngbDropdownItem
                                        class="dropdown-item" translate>
                                  <fa-icon icon="pencil-alt"></fa-icon>
                                  page.inventaire-verger.modals.add-bloc.buttonModifierLocalisation
                                </button>
                                <button (click)="supprimerLocalisation(localisation)" ngbDropdownItem
                                        class="dropdown-item" translate>
                                  <fa-icon icon="trash-alt"></fa-icon>
                                  page.inventaire-verger.modals.add-bloc.buttonSupprimerLocalisation
                                </button>
                              </div>
                            </div>
                          </div>
                        </td>
                        @if (show('departement')) { <td>{{ localisation.departement}}</td> }
                        @if (show('commune')) { <td>{{ localisation.commune}}</td> }
                        @if (show('lieuDit')) { <td>{{ localisation.lieuDit}}</td> }
                        @if (show('refCadastrale')) { <td>{{ localisation.referenceCadastrale}}</td> }
                        @if (show('situation')) { <td>{{ localisation.caracteristiqueParcelle.refSituation ? localisation.caracteristiqueParcelle.refSituation.libelle : ''}}</td> }
                        @if (show('systemeIrrigation')) { <td>{{localisation.caracteristiqueParcelle.refSystemeIrrigation ? localisation.caracteristiqueParcelle.refSystemeIrrigation.libelle : ''}}</td> }
                        @if (show('protectionGrele')) { <td>{{localisation.caracteristiqueParcelle.refProtectionGrele ? localisation.caracteristiqueParcelle.refProtectionGrele.libelle : ''}}</td> }
                        @if (show('protectionGel')) { <td>{{ localisation.caracteristiqueParcelle.refProtectionGel ?localisation.caracteristiqueParcelle.refProtectionGel.libelle : '' }}</td> }
                        @if (show('forme')) { <td>{{ localisation.caracteristiqueParcelle.refForme ? localisation.caracteristiqueParcelle.refForme.libelle : '' }}</td> }
                        @if (show('cultureBio')) { <td>{{ localisation.caracteristiqueParcelle.refCultureBio ? localisation.caracteristiqueParcelle.refCultureBio.libelle : '' }}</td> }
                        @if (show('nbBloc')) { <td>{{ localisation.nbBloc}}</td> }
                        <td></td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- ================= PANEL : Ajouter localisation ================= -->
      <div ngbAccordionItem="panelAjouterLocalisation">
        <h2 ngbAccordionHeader>
          <button ngbAccordionButton (click)="setActivePanel('panelAjouterLocalisation')">
            {{'page.inventaire-verger.modals.add-bloc.panelTitleAjouterLoca'|translate }}
          </button>
        </h2>
        <div ngbAccordionCollapse>
          <div class="accordion-body pt-0">
            <div class="tabs-wrapper">
              <ul ngbNav #localNav="ngbNav" class="nav-tabs mt-2" [activeId]="'localisationGeo'" (navChange)="changeTabLoca(localNav)">
                <li [ngbNavItem]="'localisationGeo'">
                  <button ngbNavLink>{{'page.inventaire-verger.modals.add-bloc.panelTitleLocaGeo'|translate }}</button>
                  <ng-template ngbNavContent>
                    <form [formGroup]="controleFormLocalisationGeo" (ngSubmit)="submit()" novalidate>
                      <div class="row">
                        <div class="col-lg-4">
                          <div class="mb-3">
                            <label class="form-label" translate>page.inventaire-verger.modals.add-bloc.codePostal</label>
                            <input [ngClass]="{'is-invalid': (codePostal.touched || codePostal.dirty) && codePostal.invalid || (communes && communes.length === 0)}" (keyup)="changeValueCodePostal($event)" type="text" maxlength="5" formControlName="codePostal"
                                   class="form-control">
                            @if (codePostal.touched || codePostal.dirty) {
                              @if (codePostal.errors?.required) {
                                <div class="form-error" translate>label.obligatoire</div>
                              }
                            }
                            @if (communes && communes.length === 0) {
                              <div class="form-error" translate>Aucune commune avec ce code postal</div>
                            }
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <div class="mb-3">
                            <label class="form-label" translate>page.inventaire-verger.departement</label>
                            <select [ngClass]="{'is-invalid': (departement.touched || departement.dirty) && departement.invalid}" formControlName="departement" class="form-select">
                              @for (departement of departements; track departement.code) {
                                <option [ngValue]="departement">{{departement.code}} - {{departement.nom}}</option>
                              }
                            </select>
                            @if (departement.touched || departement.dirty) {
                              @if (departement.errors?.required) {
                                <div class="form-error" translate>label.obligatoire</div>
                              }
                            }
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <div class="mb-3">
                            <label class="form-label" translate>page.inventaire-verger.commune</label>
                            <select [ngClass]="{'is-invalid': (commune.touched || commune.dirty) && commune.invalid}" formControlName="commune" class="form-select">
                              @for (commune of communes; track commune.code || commune.nom) {
                                <option [ngValue]="commune">{{commune.nom}}</option>
                              }
                            </select>
                            @if (commune.touched || commune.dirty) {
                              @if (commune.errors?.required) {
                                <div class="form-error" translate>label.obligatoire</div>
                              }
                            }
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-lg-4">
                          <div class="mb-3">
                            <label class="form-label" translate>page.inventaire-verger.lieuDit</label>
                            <input [ngClass]="{'is-invalid': (lieuDit.touched || lieuDit.dirty) && lieuDit.invalid}" (keyup)="changeLocalisationGeo()" type="text" formControlName="lieuDit"
                                   class="form-control">
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <div class="mb-3">
                            <label class="form-label" translate>page.inventaire-verger.refCadastrale</label>
                            <input [ngClass]="{'is-invalid': (refCadastrale.touched || refCadastrale.dirty) && refCadastrale.invalid}" (keyup)="changeLocalisationGeo()" type="text" formControlName="refCadastrale"
                                   class="form-control">
                          </div>
                        </div>
                        <div class="col-lg-4">
                          <div class="mb-3">
                            <label class="form-label" translate>page.inventaire-verger.situation</label>
                            <select [ngClass]="{'is-invalid': (situationLoca.touched || situationLoca.dirty) && situationLoca.invalid}"  formControlName="situation" class="form-select">
                              @for (situation of refSituations; track situation.id || situation.libelle) {
                                <option [ngValue]="situation">{{situation.libelle}}</option>
                              }
                            </select>
                            @if (situationLoca.touched || situationLoca.dirty) {
                              @if (situationLoca.errors?.required) {
                                <div class="form-error" translate>label.obligatoire</div>
                              }
                            }
                          </div>
                        </div>
                      </div>
                      @if (isAnpp) {
                        <button (click)=onTabAddLocaChange(localNav) type="button"
                                class="btn btn-primary"
                                style="background:#41905c;border:1px solid #41905c" data-dismiss="modal" aria-label="Close" translate>page.inventaire-verger.modals.add-bloc.buttonSuivant
                          <fa-icon icon="arrow-right" class="primary-icon"></fa-icon>
                        </button>
                      }
                      @if (!this.updateLocalisation && !isAnpp) {
                        <button type="submit"
                                class="btn btn-primary"
                                style="background:#41905c;border:1px solid #41905c" data-dismiss="modal" aria-label="Close" translate>
                          page.inventaire-verger.modals.add-bloc.buttonAjouterLocalisation
                        </button>
                      }
                      @if (this.updateLocalisation && !isAnpp) {
                        <button type="submit" class="btn btn-primary"
                                style="background:#41905c;border:1px solid #41905c" data-dismiss="modal" aria-label="Close" translate>
                          page.inventaire-verger.modals.add-bloc.buttonModifierLocalisation
                        </button>
                      }
                    </form>
                  </ng-template>
                </li>
                @if (isAnpp) {
                  <li [ngbNavItem]="'equipementsConduite'">
                    <button ngbNavLink>{{'page.inventaire-verger.modals.add-bloc.panelEquipementsConduites'|translate }}</button>
                    <ng-template ngbNavContent>
                      <form [formGroup]="controleFormEquipementConduite" (ngSubmit)="submit()"
                            novalidate>
                        <div class="row">
                          <div class="col-lg-4">
                            <div class="mb-3">
                              <label class="form-label" translate>page.inventaire-verger.systemeIrrigation</label>
                              <select formControlName="systemeIrrigation" class="form-select">
                                <option [ngValue]="null"></option>
                                @for (systemeIrrigation of refSystemeIrrigations; track systemeIrrigation.id || systemeIrrigation.libelle) {
                                  <option [ngValue]="systemeIrrigation">{{systemeIrrigation.libelle}}</option>
                                }
                              </select>
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="mb-3">
                              <label class="form-label" translate>page.inventaire-verger.protectionGel</label>
                              <select formControlName="protectionGel" class="form-select">
                                <option [ngValue]="null"></option>
                                @for (protectionGel of refProtectionGels; track protectionGel.id || protectionGel.libelle) {
                                  <option [ngValue]="protectionGel">{{protectionGel.libelle}}</option>
                                }
                              </select>
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="mb-3">
                              <label class="form-label" translate>page.inventaire-verger.protectionGrele</label>
                              <select formControlName="protectionGrele" class="form-select">
                                <option [ngValue]="null"></option>
                                @for (protectionGrele of refProtectionGreles; track protectionGrele.id || protectionGrele.libelle) {
                                  <option [ngValue]="protectionGrele">{{protectionGrele.libelle}}</option>
                                }
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg-4">
                            <div class="mb-3">
                              <label class="form-label" translate>page.inventaire-verger.cultureBio</label>
                              <select formControlName="cultureBio" class="form-select">
                                <option [ngValue]="null"></option>
                                @for (cultureBio of refCultureBios; track cultureBio.id || cultureBio.libelle) {
                                  <option [ngValue]="cultureBio">{{cultureBio.libelle}}</option>
                                }
                              </select>
                            </div>
                          </div>
                          <div class="col-lg-4">
                            <div class="mb-3">
                              <label class="form-label" translate>page.inventaire-verger.forme</label>
                              <select formControlName="forme" class="form-select">
                                <option [ngValue]="null"></option>
                                @for (forme of refFormes; track forme.id || forme.libelle) {
                                  <option [ngValue]="forme">{{forme.libelle}}</option>
                                }
                              </select>
                            </div>
                          </div>
                        </div>
                        @if (!this.updateLocalisation) {
                          <button type="submit"
                                  class="btn btn-primary"
                                  style="background:#41905c;border:1px solid #41905c" data-dismiss="modal" aria-label="Close" translate>
                            page.inventaire-verger.modals.add-bloc.buttonAjouterLocalisation
                          </button>
                        }
                        @if (this.updateLocalisation) {
                          <button type="submit" class="btn btn-primary"
                                  style="background:#41905c;border:1px solid #41905c" data-dismiss="modal" aria-label="Close" translate>
                            page.inventaire-verger.modals.add-bloc.buttonModifierLocalisation
                          </button>
                        }
                      </form>
                    </ng-template>
                  </li>
                }
              </ul>
              <div [ngbNavOutlet]="localNav" class="mt-3"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
